module.exports = require("regenerator-runtime");



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/regenerator/index.js
 ** module id = 744
 ** module chunks = 0
 **/